import { User } from './user.model';
import { Company } from './company.model';


export class SubscriptionRequest {
  primaryUser: User;
  secondaryUser: User;
  company: Company;
  totalDiscountPrice: number;
  reservedClientLicenses: number;
  reservedServerLicenses: number;
  serverOnlyLicenses: number;
  couponNo: any;
  support24x7: boolean;
  reservedClientPrice: any;
  client24x7Price: any;
  supportClientPrice: any;
  reservedServerPrice: any;
  server24x7Price: any;
  supportServerPrice: any;
  serverOnlyPrice: any;
  serverOnly24x7Price: any;
  supportOnlyServerPrice: any;
  email: any;
  marketplaceTokenStateId: string;
  vendorName: string;
  authCode: string;
}